import RobotsEventDispatch from "robots_event_dispatch";
import { getCookie } from 'utilities';

function newEventDispatcher() {
  return (new RobotsEventDispatch(process.env.ROBOTS_API_BASE_URL));
}

export function sendEvent(name, data) {
  if (window.BPFTracking.cookiesSet) {
    data["pid"] = getCookie("pid");
    data["sid"] = getCookie("sid");
    data["uid"] = getCookie("uid");
    newEventDispatcher().send(name, data);
  } else {
    data['event_occurred_at'] = (new Date()).toISOString();

    window.addEventListener(
      'bpfAnalyticsCookiesSet',
      function() { BPFTracking.sendEvent(name, data); },
      { once: true }
    );
  }
}
